export function cleanString (str: string) {
  return str.replace(/\/n/g, '').trim();
}
